module.exports = __webpack_public_path__ + "static/media/ic_searchtype_inletcon.9a0da6f8.svg";